import React from 'react';
import ActionDialog from '../RollResults/ActionBar/ActionDialog'
import './FeedbackDialog.css'

const FeedbackDialog = ({onClose}) => {
  return (
  <ActionDialog>
    <div className="feedback_body">
      <p>Your Feedback is Very Welcome</p>
        <p><a href="mailto:diceapp@owenmead.com">diceapp@owenmead.com</a></p>
      <button className="btnSmall" onClick={e => onClose(e)}>Ok</button>
    </div>
  </ActionDialog>
  );
}

export default FeedbackDialog


// WEBPACK FOOTER //
// ./src/Roller/FeedbackDialog.js